export var PackageDimensionsAndWeight = function PackageDimensionsAndWeight(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return packageDimensionsAndWeightBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return packageDimensionsAndWeightBuilder(strictLocalize).getDescription();
    }
  };
};
var packageDimensionsAndWeightBuilder = function packageDimensionsAndWeightBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "kVBhvj",
        defaultMessage: [{
          "type": 0,
          "value": "Verzenden via Faire - pakketbeperkingen"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "yAuVAD",
        defaultMessage: [{
          "type": 0,
          "value": "Wanneer je Verzenden met Faire gebruikt, gelden de beperkingen voor het gewicht en de afmetingen van het pakket van de vervoerder. Lees de Helpcentrum-artikelen die we voor jou hebben gevonden om je opties te zien of neem contact met ons op voor meer hulp. Je kunt ook proberen een andere vervoerder te gebruiken of Met eigen vervoerder verzenden te kiezen."
        }]
      })];
    }
  };
};